module.exports = __webpack_public_path__ + "img/new_index_industry_icon3.b4557257.png";